import { wrappedAxios as axios } from './axios';

import {
  Environment,
  resolveResponse,
  resolveRejected,
} from 'common';

export class OrderProvider {

  static async createOrder(id, tickets, merch, packages, customFields, couponCode = null) {

    try {

      let url = `${Environment.apiHost}tickets/order`;

      const body = {
        tickets,
        merch,
        packages,
        event_id: id,
        custom_fields: customFields
      };

      if (couponCode) {
        body.coupon_code = couponCode;
      }

      let res = await axios.post(url, body);

      return resolveResponse(res);

    } catch (ex) {

      return resolveRejected(ex);
    }
  }

  static async getOrderByOrderId(id, result) {

    try {

      let res = await axios.get(`${Environment.apiHost}tickets/order-by-id?orderId=${id}&result=${result}`);

      return resolveResponse(res);

    } catch (ex) {

      return resolveRejected(ex);
    }
  }

  static async cancelOrder(id) {

    try {

      let res = await axios.post(`${Environment.apiHost}tickets/cancel-order`, {
        order_id: id
      });

      return resolveResponse(res);

    } catch (ex) {

      return resolveRejected(ex);
    }
  }

  static async getScheduledOrdersByLoggedInUser(token) {
    try {
      let res = await axios.post(`${Environment.apiHost}notification/whatsapp/scheduled-orders/callback`, {
        token: token
      });
      return resolveResponse(res);
    } catch (ex) {
      return resolveRejected(ex);
    }
  }

  static async getOrdersByLoggedInUser() {
    try {
      let res = await axios.get(`${Environment.apiHost}tickets/orders-by-logged-in-user`);
      return resolveResponse(res);
    } catch (ex) {
      return resolveRejected(ex);
    }
  }

  static async updateOrderForLoggedInUser(orderId, customFields) {
    try {
      let res = await axios.post(`${Environment.apiHost}tickets/update-order-for-logged-in-user/${orderId}`, {
        custom_fields: customFields
      });
      return resolveResponse(res);
    } catch (ex) {
      return resolveRejected(ex);
    }
  }

  static async getCoupon(couponCode, eventId) {
    try {
      let res = await axios.get(`${Environment.apiHost}tickets/get-coupon?coupon_code=${couponCode}&event_id=${eventId}`);
      return resolveResponse(res);
    } catch (ex) {
      return resolveRejected(ex);
    }
  }

  static async reserveSeat(eventId, seatId, ticketTypeId, action, orderId) {
    try {
      let res = await axios.post(`${Environment.apiHost}tickets/reserve-seat`, {
        event_id: eventId,
        seat_id: seatId,
        ticket_type_id: ticketTypeId,
        action: action,
        order_id: orderId
      });
      return resolveResponse(res);
    } catch (ex) {
      let resolvedErr = resolveRejected(ex);
      if (resolvedErr.message?.startsWith('Seat is already reserved')) {
        return {
          ok: false,
          message: 'This seat has just been reserved by another customer. Please select a different seat.',
          data: {
            reloadSeats: true
          }
        };
      }
      return resolvedErr;
    }
  }

  static async unreserveSeats(eventId, orderId, seatIds) {
    try {
      let res = await axios.post(`${Environment.apiHost}tickets/unreserve-seats`, {
        event_id: eventId,
        order_id: orderId,
        seat_ids: seatIds
      });
      return resolveResponse(res);
    } catch (ex) {
      return resolveRejected(ex);
    }
  }

  static async reserveGeneralAdmissionSeat(eventId, blockId, ticketTypeId, action, orderId) {
    try {
      let res = await axios.post(`${Environment.apiHost}tickets/reserve-general-admission-seat`, {
        event_id: eventId,
        block_id: blockId,
        ticket_type_id: ticketTypeId,
        action: action,
        order_id: orderId
      });
      return resolveResponse(res);
    } catch (ex) {
      return resolveRejected(ex);
    }
  }

  static async createEmptyOrder(eventId, customFields = null) {
    try {
      const body = {};
      if (eventId) {
        body.event_id = eventId;
      }
      if (customFields) {
        body.custom_fields = customFields;
      }
      
      let res = await axios.post(`${Environment.apiHost}tickets/order/empty`, body);
      return resolveResponse(res);
    } catch (ex) {
      return resolveRejected(ex);
    }
  }

  static async getOrderSeats(orderId) {
    try {
      let res = await axios.get(`${Environment.apiHost}tickets/order/${orderId}/seats?time=${Date.now()}`);
      return resolveResponse(res);
    } catch (ex) {
      return resolveRejected(ex);
    }
  }

  static async createSeatsCheckout(orderId, callbackUrl, generalAdmissionTickets = [], couponCode = null, customFields = null, packages = null) {
    try {
      const body = {
        callbackUrl: callbackUrl,
        general_admission_tickets: generalAdmissionTickets
      };
      if (couponCode) {
        body.coupon_code = couponCode;
      }
      if (customFields?.length) {
        body.custom_fields = customFields;
      }
      if (packages?.length) {
        body.packages = packages;
      }
      let res = await axios.post(`${Environment.apiHost}tickets/order/${orderId}/create-seats-checkout`, body);
      return resolveResponse(res);
    } catch (ex) {
      return resolveRejected(ex);
    }
  }
}

